var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-align-center"},[_c('rd-tag-group',{staticClass:"rd-tag-group",attrs:{"list":_vm.row.tagList?.map(tag => tag.tagName),"max":1,"row":{ ..._vm.row, tag_arr: _vm.row.tagList?.map(tag => ({ id: tag.tagId, tag_name: tag.tagName })) },"canEdit":_vm.$auth.hasPermi('addTag:local-material'),"rowIsHover":_vm.row.visible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }